import {Component} from "@angular/core";
import {AditivoService} from 'src/app/services/aditivo.service';
import {Aditivo} from 'src/app/model/Aditivo';
import {Router} from "@angular/router";
import {PesquisaAditivoStateService} from "src/app/services/pesquisa-aditivo.state.service";

@Component({
  selector: 'pesquisa-aditivo',
  templateUrl: './pesquisa-aditivo.component.html',
  styleUrls: ['./pesquisa-aditivo.component.scss'],
  standalone: false
})
export class PesquisaAditivoComponent {
  exibePesquisaAvancada: boolean;
  aditivos: Aditivo[];
  msg: string;

  // Critério básico
  criterio: string;
  // Critérios Avançados
  criterioDatProtocoloInicio: Date;
  criterioDatProtocoloFim: Date;
  criterioSituacao: string;
  criterioProposta: string;
  criterioAno: number;
  criterioPac: string;
  criterioComprador: string;


  constructor(
    private service: AditivoService,
    private router: Router,
    private state: PesquisaAditivoStateService,
  ) {
  }

  ngOnInit(): void {
    this.msg = "Faça uma pesquisa acima";
    //this.pesquisar();

    this.state.state$.subscribe(
      s => {
        this.exibePesquisaAvancada = s.exibePesquisaAvancada;
        this.aditivos = [...s.aditivos];
        this.criterio = s.criterio;
        this.criterioDatProtocoloInicio = s.criterioDatProtocoloInicio,
          this.criterioDatProtocoloFim = s.criterioDatProtocoloFim,
          this.criterioSituacao = s.criterioSituacao;
        this.criterioProposta = s.criterioProposta;
        this.criterioAno = s.criterioAno;
        this.criterioPac = s.criterioPac;
        this.criterioComprador = s.criterioComprador;

        this.msg = this.aditivos?.length ? null : "Faça uma pesquisa acima";
      })
  }

  pesquisar() {
    if (this.criterioSituacao == "null") {
      this.criterioSituacao = null;
    }
    this.msg = "...";
    if (this.exibePesquisaAvancada) {
      this.service.pesquisaAditivoAvancada( //
        this.criterioDatProtocoloInicio,
        this.criterioDatProtocoloFim,
        this.criterioSituacao,
        this.criterioProposta,
        this.criterioAno,
        this.criterioPac,
        this.criterioComprador
      ).subscribe(c => {
        this.aditivos = c.list;
        this.msg = null;
        this.state.update({
          exibePesquisaAvancada: this.exibePesquisaAvancada,
          aditivos: this.aditivos,
          criterioDatProtocoloInicio: this.criterioDatProtocoloInicio,
          criterioDatProtocoloFim: this.criterioDatProtocoloFim,
          criterioSituacao: this.criterioSituacao,
          criterioProposta: this.criterioProposta,
          criterioAno: this.criterioAno,
          criterioPac: this.criterioPac,
          criterioComprador: this.criterioComprador
        });
      });
    } else {
      this.service.pesquisaAditivo(this.criterio).subscribe(c => {
        this.aditivos = c.list;
        this.msg = null;
        this.state.update({
          exibePesquisaAvancada: this.exibePesquisaAvancada,
          criterio: this.criterio,
          aditivos: this.aditivos,
        });
      });
    }
  }

  alternarPesquisa() {
    this.exibePesquisaAvancada = !this.exibePesquisaAvancada;
  }

  onVisualizarClick(aditivo: Aditivo) {
    this.router.navigate(["/consulta-aditivo/" + aditivo.id]);
  }
}
